import { render, staticRenderFns } from "./Img-upload.vue?vue&type=template&id=6f42980d&scoped=true&"
import script from "./Img-upload.vue?vue&type=script&lang=js&"
export * from "./Img-upload.vue?vue&type=script&lang=js&"
import style0 from "./Img-upload.vue?vue&type=style&index=0&id=6f42980d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42980d",
  null
  
)

export default component.exports